import { flagError } from 'error-handling'
import { fundraisingGate } from 'fundraising-core/host'
import { cmsSettings, DEFAULT_SETTINGS } from '~/libs/cms'
import type { Settings } from '~/types/cms'

export const useCrmHealthCheck = async () => {
  // Filled by readFallbackForms below, and left at the defaults when that read fails.
  let settings: Settings = DEFAULT_SETTINGS

  const { mode, crmHealthy } = await fundraisingGate({
    checkCrmHealth: async () => (await $fetch('/api/health')).success,
    readFallbackForms: async () => {
      const result = await cmsSettings()
      settings = result.settings
      // An absent entry is not the flag reading off: the switch is unreachable, and staff
      // flipping it would see nothing happen. The entry is gone, unpublished, or in another space.
      if (!result.success) {
        flagError(
          new Error('no Contentful settings entry: the maintenance switch is dead'),
          '[useCrmHealthCheck] settings entry missing',
        )
      }
      // `cmsSettings` casts the Contentful fields, so the type is a claim, not a check. Coercing
      // would read the string 'false' as the switch being ON and divert every donor.
      if (typeof settings.fallbackForms !== 'boolean') {
        flagError(
          new Error('non-boolean fallbackForms: the maintenance switch is dead'),
          '[useCrmHealthCheck] settings entry malformed',
        )
        return false
      }
      return settings.fallbackForms
    },
    // Contentful settings fetch can fail on transient network errors (e.g. mobile Safari).
    onError: err => {
      flagError(err, '[useCrmHealthCheck] Failed to fetch CMS settings, using defaults')
    },
  })

  // TODO: Implement email mode
  const integrationMode = ref<'integrated' | 'email' | 'manual'>(
    mode === 'maintenance' ? 'manual' : 'integrated',
  )

  return { integrationMode, crmHealthy, settings }
}
